import { ABOUT, IMPACT_STATS } from "@/data/content";
import Counter from "@/components/common/Counter";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Impact() {
  return (
    <section className="section-y bg-white" data-testid="home-impact">
      <div className="container-sf">
        {/* Impact Stats Row */}
        <div className="rounded-3xl bg-gradient-to-br from-[var(--brand-blue)] via-[#254DAA] to-[#1a2f68] p-10 md:p-14 relative overflow-hidden mb-16">
          <div className="grain-overlay" />
          <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-[var(--brand-orange)]/20 blur-3xl" />

          <div className="relative grid md:grid-cols-[1.2fr,2fr] gap-10 items-end">
            <div>
              <div className="eyebrow text-[var(--brand-orange)] mb-3">Dampak Kami</div>
              <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
                Ekosistem dampak yang{" "}
                <span className="font-serif-display italic font-normal text-[var(--brand-orange)]">terukur</span>.
              </h2>
              <Link to="/impact" className="btn-primary mt-8" data-testid="impact-see-all">
                Lihat Detail Impact <ArrowRight className="h-4 w-4" />
              </Link>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {IMPACT_STATS.map((s, i) => (
                <div key={i} className="relative">
                  <div className="text-5xl md:text-6xl font-bold text-white tracking-tight">
                    <Counter end={s.value} suffix={s.suffix} />
                  </div>
                  <div className="mt-2 text-sm text-slate-200/90 leading-tight max-w-[160px]">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Impact Model - 5 stages */}
        <div className="grid lg:grid-cols-[1fr,1.5fr] gap-12 items-start">
          <div className="lg:sticky lg:top-28">
            <div className="eyebrow mb-4">Sauyunan Impact Model</div>
            <h3 className="text-3xl md:text-4xl font-bold leading-tight text-slate-900">
              Lima tahapan menuju{" "}
              <span className="font-serif-display italic font-normal text-[var(--brand-blue)]">transformasi</span> sistemik.
            </h3>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Setiap intervensi dirancang untuk berkembang dari bantuan mendesak hingga menjadi transformasi jangka panjang yang berkelanjutan.
            </p>
          </div>

          <div className="relative">
            {/* Connecting line */}
            <div className="absolute left-6 top-4 bottom-4 w-[2px] bg-gradient-to-b from-[var(--brand-blue)] to-[var(--brand-orange)] opacity-30" />
            <div className="space-y-4">
              {ABOUT.impactModel.map((step, i) => (
                <div key={step.stage} className="relative pl-16 group" data-testid={`impact-stage-${step.title.toLowerCase()}`}>
                  <div className={`absolute left-0 top-1 h-12 w-12 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg ${i % 2 === 0 ? "bg-[var(--brand-blue)]" : "bg-[var(--brand-orange)]"}`}>
                    {step.stage}
                  </div>
                  <div className="card-sf p-6 group-hover:border-[var(--brand-orange)]/40">
                    <h4 className="text-xl font-bold text-slate-900">{step.title}</h4>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{step.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
